import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// Setting up the firestore app
const store = firebase.firestore();

// Defining a new type that can only take two possible values
type UserType = "donor" | "requester";

/**
 * Fetches and returns details of a user from the database.
 * @param uid id of the user
 * @param userType type of the user
 */
export async function getUserDetails(
  uid: string,
  userType: UserType
): Promise<any> {
  return new Promise((resolve, reject) => {
    store
      .collection(userType)
      .doc(uid)
      .get()
      .then((details: any) => {
        if (details.exists) resolve(details.data());
        else reject(null);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * Uploads and/or updates (merges) the details of user on the database.
 * @param data data with updated details
 * @param uid id of the user
 * @param userType type of user
 */
export async function updateUserData(
  data: any,
  uid: string,
  userType: UserType
) {
  return store
    .collection(userType)
    .doc(uid)
    .set({ ...data }, { merge: true });
}
